import http, { unwrap } from './http'

export async function loginAdmin(credentials) {
  return unwrap(await http.post('/auth/login', credentials))
}

export async function getCurrentAdmin() {
  return unwrap(await http.get('/auth/me'))
}
